export default "https://cdn-static.gokick.com/assets/f142aa9afb455fb94cf2718539e479c66bf8a410/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";